
import { Component, Prop, Vue } from 'vue-property-decorator';
import SettingEntity from '@/services/Internal-Tickets/interfaces/setting.entity';

@Component
export default class EditSettingDialog extends Vue {
  @Prop() private readonly template!: SettingEntity;
  @Prop() private readonly onDelete!: CallableFunction;

  public name: string = '';
  public color: string = '';
  public id: number;


  private visible: boolean = true;

  public async mounted(): Promise<void> {
    console.log('we got here')
    this.name = this.template.name;
    this.color = this.template.color;
    this.id = this.template.id;
  }

  private destroyComponent(): void {
    this.$emit('close');
  }

  public updateComponent(name: string, color: string): void {
    console.log('we got in update dialog')
    this.$emit('update', { id: this.id, name, color });
  }
}
